export const API = "https://api.thyba.finance"
export const host = "https://thyba.finance"

// export const API = "https://demo.api.thyba.finance"
// export const host = "https://demo.thyba.finance"